import React from "react";
import { NavLink } from "react-router-dom";
import "./Footer.scss";
import HomeIcon from "../../assets/images/icons/home-svgrepo-com.svg";
import LeaveIcon from "../../assets/images/icons/paper-pen-svgrepo-com.svg";
import UserIcon from "../../assets/images/icons/profile-svgrepo-com.svg";
import ProjectsIcon from "../../assets/images/icons/network-svgrepo-com.svg";
import { useLocation } from "react-router-dom";
import useCheckRoute from "ccustomHook/useCheckRoute";

const Footer = () => {

  const allSavedProjectsInStorage =
    localStorage.getItem("all-saved-projects-in-storage") == null
      ? []
      : JSON.parse(localStorage.getItem("all-saved-projects-in-storage"));

  return useCheckRoute("/login") ? null : (
    <div className="footer">
      <ul>
        <li>
          <NavLink
            to="/profile"
            className={({ isActive }) =>
              isActive ? "selected-navlink footer-navlink" : "footer-navlink"
            }
          >
            <img className="bottom-navigation-icon" src={UserIcon} alt="icon" />
            <span className="bottom-navigation-text">پروفایل</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/leave"
            className={({ isActive }) =>
              isActive ? "selected-navlink footer-navlink" : "footer-navlink"
            }
          >
            <img
              className="bottom-navigation-icon"
              src={LeaveIcon}
              alt="icon"
            />
            <span className="bottom-navigation-text">مرخصی</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/projects"
            className={({ isActive }) =>
              isActive ? "selected-navlink footer-navlink" : "footer-navlink"
            }
          >
            {allSavedProjectsInStorage.length > 0 && (
              <span className="show-saved-projects-quantity">
                {allSavedProjectsInStorage.length}
              </span>
            )}
            <img
              className="bottom-navigation-icon"
              src={ProjectsIcon}
              alt="icon"
            />
            <span className="bottom-navigation-text">پروژه ها</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/services"
            className={({ isActive }) =>
              isActive ? "selected-navlink footer-navlink" : "footer-navlink"
            }
          >
            <img className="bottom-navigation-icon" src={HomeIcon} alt="icon" />
            <span className="bottom-navigation-text">صفحه اصلی</span>
          </NavLink>
        </li>
      </ul>
    </div>
  );
};
export default Footer;
